import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    redirect: '/home',
    meta: {
      hidden: true,
    },
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: '首页',
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/common/login/index.vue'),
    meta: {
      title: '登录',
      hidden: true,
    },
  },
]

export const menusRoutes: RouteRecordRaw[] = [
  {
    path: '/newReaction',
    name: 'newReaction',
    component: () => import('@/layouts/index.vue'),
    redirect: '/newReaction/newTask/index',
    meta: {
      title: '新反应发现',
      roles: ['user'],
    },
    children: [
      {
        path: '/newReaction/newTask/index',
        name: 'newReactionNewTaskIndex',
        component: () => import('@/views/newReaction/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/newReaction/currentTask/index',
        name: 'newReactionCurrentTaskIndex',
        component: () => import('@/views/newReaction/currentTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/newReaction/history/index',
        name: 'newReactionHistoryIndex',
        component: () => import('@/views/newReaction/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/synthesisPlatform',
    name: 'synthesisPlatform',
    component: () => import('@/layouts/index.vue'),
    redirect: '/synthesisPlatform/newTask/index',
    meta: {
      title: '合成平台',
      roles: ['user'],
    },
    children: [
      {
        path: '/synthesisPlatform/newTask/index',
        name: 'synthesisPlatformNewTaskIndex',
        component: () => import('@/views/synthesisPlatform/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/synthesisPlatform/currentTask/index',
        name: 'synthesisPlatformCurrentTaskIndex',
        component: () => import('@/views/synthesisPlatform/currentTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/synthesisPlatform/history/index',
        name: 'synthesisPlatformHistoryIndex',
        component: () => import('@/views/synthesisPlatform/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/conditionFiltering',
    name: 'conditionFiltering',
    component: () => import('@/layouts/index.vue'),
    redirect: '/conditionFiltering/newTask/index',
    meta: {
      title: '条件筛选',
      roles: ['user'],
    },
    children: [
      {
        path: '/conditionFiltering/newTask/index',
        name: 'conditionFilteringNewTaskIndex',
        component: () => import('@/views/conditionFiltering/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/conditionFiltering/currentTask/index',
        name: 'conditionFilteringCurrentTaskIndex',
        component: () => import('@/views/conditionFiltering/currentTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/conditionFiltering/history/index',
        name: 'conditionFilteringHistoryIndex',
        component: () => import('@/views/conditionFiltering/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/librarySynthesis',
    name: 'librarySynthesis',
    component: () => import('@/layouts/index.vue'),
    redirect: '/librarySynthesis/newTask/index',
    meta: {
      title: '库合成',
      roles: ['user'],
    },
    children: [
      {
        path: '/librarySynthesis/newTask/index',
        name: 'librarySynthesisNewTaskIndex',
        component: () => import('@/views/librarySynthesis/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/librarySynthesis/currentTask/index',
        name: 'librarySynthesisCurrentTaskIndex',
        component: () => import('@/views/librarySynthesis/currentTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/librarySynthesis/history/index',
        name: 'librarySynthesisHistoryIndex',
        component: () => import('@/views/librarySynthesis/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/crystallized',
    name: 'crystallized',
    component: () => import('@/layouts/index.vue'),
    redirect: '/crystallized/newTask/index',
    meta: {
      title: '结晶平台',
      roles: ['user'],
    },
    children: [
      {
        path: '/crystallized/newTask/index',
        name: 'crystallizedNewTaskIndex',
        component: () => import('@/views/crystallized/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/crystallized/currentTask/index',
        name: 'crystallizedCurrentTaskIndex',
        component: () => import('@/views/crystallized/newTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/crystallized/history/index',
        name: 'crystallizedHistoryIndex',
        component: () => import('@/views/crystallized/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/optimization',
    name: 'optimization',
    component: () => import('@/layouts/index.vue'),
    redirect: '/optimization/newTask/index',
    meta: {
      title: '条件优化',
      roles: ['user'],
    },
    children: [
      {
        path: '/optimization/newTask/index',
        name: 'optimizationNewTaskIndex',
        component: () => import('@/views/optimization/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/optimization/currentTask/index',
        name: 'optimizationCurrentTaskIndex',
        component: () => import('@/views/optimization/currentTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/optimization/history/index',
        name: 'optimizationHistoryIndex',
        component: () => import('@/views/optimization/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/building',
    name: 'building',
    component: () => import('@/layouts/index.vue'),
    redirect: '/building/newTask/index',
    meta: {
      title: '数据建库',
      roles: ['user'],
    },
    children: [
      {
        path: '/building/newTask/index',
        name: 'buildingNewTaskIndex',
        component: () => import('@/views/building/newTask/index.vue'),
        meta: {
          title: '新任务',
          showMenu: true,
        },
      },
      {
        path: '/building/currentTask/index',
        name: 'buildingCurrentTaskIndex',
        component: () => import('@/views/building/currentTask/index.vue'),
        meta: {
          title: '当前任务',
          showMenu: true,
        },
      },
      {
        path: '/building/history/index',
        name: 'buildingHistoryIndex',
        component: () => import('@/views/building/history/index.vue'),
        meta: {
          title: '历史',
          showMenu: true,
        },
      },
    ],
  },
  {
    path: '/inverseSynthesis',
    name: 'inverseSynthesis',
    component: () => import('@/layouts/index.vue'),
    redirect: '/inverseSynthesis/index',
    meta: {
      title: '逆合成预测',
      roles: ['user'],
    },
    children: [
      {
        path: '/inverseSynthesis/index',
        name: 'inverseSynthesisIndex',
        component: () => import('@/views/inverseSynthesis/index/index.vue'),
        meta: {
          title: '逆合成预测',
        },
      },
    ],
  },
  {
    path: '/forwardReaction',
    name: 'forwardReaction',
    component: () => import('@/layouts/index.vue'),
    redirect: '/forwardReaction/index',
    meta: {
      title: '正向反应预测',
      roles: ['user'],
    },
    children: [
      {
        path: '/forwardReaction/index',
        name: 'forwardReactionIndex',
        component: () => import('@/views/forwardReaction/index/index.vue'),
        meta: {
          title: '正向反应预测',
        },
      },
    ],
  },
  {
    path: '/admin/inverseSynthesis',
    name: 'adminInverseSynthesis',
    component: () => import('@/layouts/index.vue'),
    redirect: '/admin/inverseSynthesis/index',
    meta: {
      title: '逆合成预测',
      roles: ['admin'],
    },
    children: [
      {
        path: '/admin/inverseSynthesis/index',
        name: 'adminInverseSynthesisIndex',
        component: () => import('@/views/admin/inverseSynthesis/index.vue'),
        meta: {
          title: '逆合成预测',
        },
      },
    ],
  },
  {
    path: '/admin/forwardReaction',
    name: 'adminForwardReaction',
    component: () => import('@/layouts/index.vue'),
    redirect: '/admin/forwardReaction/index',
    meta: {
      title: '正向反应预测',
      roles: ['admin'],
    },
    children: [
      {
        path: '/admin/forwardReaction/index',
        name: 'adminForwardReactionIndex',
        component: () => import('@/views/admin/forwardReaction/index.vue'),
        meta: {
          title: '正向反应预测',
        },
      },
    ],
  },
  {
    path: '/admin/moduleManagement',
    name: 'moduleManagement',
    component: () => import('@/layouts/index.vue'),
    redirect: '/admin/moduleManagement/index',
    meta: {
      title: '功能模块管理',
      roles: ['admin'],
    },
    children: [
      {
        path: '/admin/moduleManagement/index',
        name: 'moduleManagementIndex',
        component: () => import('@/views/admin/moduleManagement/index.vue'),
        meta: {
          title: '功能模块管理',
        },
      },
    ],
  },
  {
    path: '/setting/password',
    name: 'settingPassword',
    component: () => import('@/layouts/index.vue'),
    redirect: '/setting/password/index',
    meta: {
      title: '设置',
      roles: ['user', 'admin'],
    },
    children: [
      {
        path: '/setting/password/index',
        name: 'settingPasswordIndex',
        component: () => import('@/views/setting/password/index.vue'),
        meta: {
          title: '修改登录密码',
        },
      },
    ],
  },
  {
    path: '/admin/setting',
    name: 'adminSetting',
    component: () => import('@/layouts/index.vue'),
    redirect: '/setting/setting/userList',
    meta: {
      title: '设置',
      roles: ['admin'],
    },
    children: [
      {
        path: '/admin/setting/userList',
        name: 'adminSettingUserList',
        component: () => import('@/views/admin/userList/index.vue'),
        meta: {
          title: '用户信息管理',
        },
      },
      {
        path: '/admin/setting/logList',
        name: 'adminSettingLogList',
        component: () => import('@/views/admin/logList/index.vue'),
        meta: {
          title: '操作日志管理',
        },
      },
      {
        path: '/admin/setting/systemConfig',
        name: 'adminSettingSystemConfig',
        component: () => import('@/views/admin/systemConfig/index.vue'),
        meta: {
          title: '系统设置',
        },
      },
      {
        path: '/admin/setting/password',
        name: 'adminSettingPassword',
        component: () => import('@/views/setting/password/index.vue'),
        meta: {
          title: '修改登录密码',
        },
      },
    ],
  },
]

// 手机端的路由
export const mobileMenusRoutes: RouteRecordRaw[] = [

]

export default routes
